import { FormattedNumber } from 'react-intl';

type Props = {
  count: number;
  /**
   * @default 1_000_000
   */
  limit?: number;
};

const MAX_JOB_COUNT = 1_000_000;

// This helper hides the count if bigger than 1_000_000,
// to prevent the disclosure of our real job inventory count (product decision)
export const LimitedJobCount: React.FC<Props> = ({
  count,
  limit = MAX_JOB_COUNT,
}) => {
  return count > limit ? (
    <>
      <FormattedNumber value={limit} />+
    </>
  ) : (
    <FormattedNumber value={count} />
  );
};
